import { Button } from "@/components/ui/button";
import { GenerativeCard } from "@/components/generative-ui/shared/GenerativeCard";
import type {
  RoutingRuleCard,
  CardActionHandler,
} from "@/components/generative-ui/envelope/types";

export interface Props {
  card: RoutingRuleCard;
  onAction?: CardActionHandler;
}

export function RoutingRuleView({ card, onAction }: Props) {
  return (
    <GenerativeCard.Root variant="default">
      <GenerativeCard.Header>
        <span className="text-xs uppercase tracking-wide text-pink-600">Regra de roteamento</span>
        <span className="text-xs text-muted-foreground">· {card.source}</span>
      </GenerativeCard.Header>
      <GenerativeCard.Body>
        <div className="space-y-1 text-sm">
          <div>Quando: <span className="font-medium">{card.condition_summary}</span></div>
          <div>Direcionar para: <span className="font-medium">{card.target_persona_name}</span></div>
          <div className="text-xs text-muted-foreground">Prioridade {card.priority}</div>
        </div>
      </GenerativeCard.Body>
      <GenerativeCard.Actions>
        <Button
          disabled={!card.rule_id}
          onClick={() =>
            onAction?.({
              intent: "activate_routing_rule",
              payload: { rule_id: card.rule_id ?? "" },
            })
          }
        >
          Ativar regra
        </Button>
      </GenerativeCard.Actions>
    </GenerativeCard.Root>
  );
}
